import { useTranslate } from 'core/hooks/useTranslate';
import { MAIN_CONTENT_ID } from 'core/layout/constants';
import PdfViewerFullScreen from 'core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from 'core/store/index';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TextHtml } from 'ui';

const TermsOfUse = () => {
  const { t } = useTranslate();
  const scopes = useSelector((state) => coreEntities.langs.selectors.getLangScopes(state));
  const [legal, setLegal] = useState('');
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  useEffect(() => {
    if (scopes && scopes.length > 0) {
      let legalScope = scopes.filter((scope) => scope.scope === 'legal');
      if (legalScope && legalScope.length > 0) {
        setLegal(legalScope[0].json);
      }
    }
  }, [scopes]);

  useEffect(() => {
    if (legal?.endsWith('pdf')) {
      setShowPdfViewer(true);
    } else {
      setShowPdfViewer(false);
    }
  }, [legal]);

  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1}>
      <h1 className="sr-only">{t('titles:Terms')}</h1>
      {showPdfViewer ? (
        <PdfViewerFullScreen ariaLabel={t('titles:Terms')} url={legal} />
      ) : (
        <div style={{ padding: '40px' }}>
          <TextHtml text={legal} />
        </div>
      )}
    </main>
  );
};

export default TermsOfUse;
